const Requested = 0;
const Rejected = 1;
const Approved = 2;
const Deleted = 3;

export default {
	Requested,
	Rejected,
	Approved,
	Deleted,
};
